<template>
  <div>
    <v-container>
      <v-row class="mt-8" dense>
        <v-col cols="12">
          <div class="marketplaceTitle"><b>Marketplace</b></div>
        </v-col>
        <v-col class="mt-8" cols="12">
          <v-row dense>
            <v-col cols="12" md="5">
              <v-autocomplete
                :items="collectibles"
                v-model="filter.collectible"
                item-text="name"
                item-value="_id"
                label="Collectible"
                outlined
                hide-details
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="8" md="4">
              <v-autocomplete
                :items="artists"
                v-model="filter.artist"
                label="Artist"
                outlined
                hide-details
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="4" md="3">
              <v-autocomplete
                :items="rarities"
                v-model="filter.rarity"
                label="Rarity"
                outlined
                hide-details
                dense
                clearable
              />
            </v-col>
            <!-- <v-col cols="7">
              <v-text-field
                v-model="query"
                label="Search"
                outlined
                hide-details
                dense
                clearable
              />
            </v-col> -->
          </v-row>
        </v-col>
        <template v-for="listing in listings">
          <v-col :key="listing._id" cols="6" sm="4" md="3">
            <TokenView
              :collectible="listing.collectible"
              :listing="listing"
              :token="listing.token"
              :moment="listing.moment"
              :showPrice="true"
            />
          </v-col>
        </template>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'Homes',

    components: {
      TokenView: () => import('../components/TokenView.vue'),
    },

    props: ['listings', 'rarities', 'artists'],

    data: () => ({
      filter: {
        collectible: null,
        rarity: null,
      },
    }),

    computed: {
      ...mapState({
        collectibles: (state) => state.collectibles,
      }),
    },

    watch: {
      filter: {
        handler(val) {
          const filter = {};
          if (val.artist) {
            filter.artist = val.artist;
          }
          if (val.collectible) {
            filter.collectibles = [val.collectible];
          }
          if (val.rarity) {
            filter.rarity = val.rarity;
          }
          this.$emit('filterChanged', filter);
        },
        deep: true,
      },
    },

    mounted() {
      this.$emit('refreshUser');
    },

    methods: {},
  };
</script>

<style scoped>
  .marketplaceTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 57px !important;
    line-height: 64px !important;
    color: #1c1c1c;
  }
</style>
